import contextCreator from "../contextCreator";
import AddListingReducer, { initialState } from "./addListing.reducer";

// eslint-disable-next-line react-hooks/rules-of-hooks
const [state, dispatch, provider] = contextCreator(
  AddListingReducer,
  initialState
);

export const useAddListingState = state;
export const useAddListingDispatch = dispatch;
export const AddListingProvider = provider;
